import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class OrganizationsService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    if (obj) {
      variables = {
        first: obj.paginationData.pageSize,
        after: obj.paginationData.after
          ? obj.paginationData.after.endCursor
          : null,
        searchParam: obj.searchParam || null,
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetOrganizations(
          $first: Int
          $after: String
          $searchParam: String
        ) {
          organizations(
            first: $first
            after: $after
            searchParam: $searchParam
          ) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                name
                verified
                approved
              }
              cursor
            }
            totalCount
          }
        }
      `,
      variables,
      errorPolicy: "all",
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
                {
                    organization(id: "${id}") {
                        id
                        name
                        address
                        phoneNumber
                        fax
                        website
                        shortDescription
                        description
                        verified
                        approved
                        logo {
                            id
                            url
                        }
                        guides {
                            id
                            name
                        }
                        photos {
                            id
                            url
                            originalUrl
                            path
                            mimetype
                        }
                    }
                }
            `,
    }).valueChanges;
  }

  create(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createOrganization($name: String!) {
          createOrganization(organization: { name: $name }) {
            id
          }
        }
      `,
      variables: {
        name: obj.name,
      },
    });
  }

  update(obj) {
    const guides = [];
    if (obj.guides) {
      obj.guides.forEach((guide) => guides.push({ id: guide.id }));
    }
    return this.apollo.mutate({
      mutation: gql`
        mutation updateOrganization(
          $id: ID!
          $name: String!
          $description: String
          $address: String
          $phoneNumber: String
          $fax: String
          $website: String
          $shortDescription: String
          $approved: Boolean
          $verified: Boolean
          $guides: [OrganizationGuideInput]
        ) {
          updateOrganization(
            organization: {
              id: $id
              name: $name
              description: $description
              address: $address
              phoneNumber: $phoneNumber
              fax: $fax
              website: $website
              shortDescription: $shortDescription
              approved: $approved
              verified: $verified
              guides: $guides
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        name: obj.name,
        description: obj.description,
        address: obj.address,
        phoneNumber: obj.phoneNumber,
        fax: obj.fax,
        website: obj.website,
        shortDescription: obj.shortDescription,
        approved: obj.approved,
        verified: obj.verified,
        guides: guides,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
                mutation removeOrganization {
                    removeOrganization(organization: {id: "${obj.id}"}) {
                        success
                    }
                }
            `,
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/organizations.service.ts